<template>
  <div class="container-fluid footer">
    <img src="@/assets/illustrations/illustration-1.svg" alt="Thoughtjumper" class="footer__img" />
    <span class="footer__texts">Copyright &copy; 2012-{{ getCurrentYear }}</span>
    <span class="footer__texts">Edvanta Technologies.</span>
    <span class="footer__texts">All rights reserved</span>
  </div>
</template>

<script>
export default {
  name: 'Footer',

  computed: {
    getCurrentYear() {
      return new Date().getFullYear();
    },
  },
};
</script>

<style lang="scss" scoped>
@import "../scss/abstracts/variables";
.footer {
  color: $black;
  // box-shadow: 0em -0.125em 0.3125em rgb(0 0 0 / 10%);
  height: 8vh;
  display: flex;
  align-items: center;
  justify-content: center;
  /* margin-top: 2em; */
  font-size: .8rem;
  position: absolute;
  bottom: 1rem;
  left: 0;
  text-align: center;
  display: flex;
  align-items: center;
  flex-direction: column;
  position: relative;

  &__img {
    position: absolute;
    top: -9rem;
    max-width: 17rem;
  }
}
</style>
